var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      class: _vm.iconClasses,
      style: _vm.iconStyles,
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "18",
        viewBox: "0 0 17 18",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10.5586 0.991699C13.8837 0.991699 16.58 3.68679 16.5801 7.01184C16.5801 8.32714 16.1566 9.54296 15.4409 10.5334L14.552 10.0202C15.1838 9.1829 15.5591 8.14144 15.5591 7.01184C15.559 4.25038 13.3201 2.012 10.5586 2.012C10.2559 2.01202 9.9597 2.03999 9.67181 2.09155C11.216 3.18151 12.2256 4.9781 12.2257 7.01184C12.2257 7.54721 12.1542 8.06581 12.023 8.55994L11.1016 8.02799C11.1694 7.69985 11.2054 7.36004 11.2054 7.01184C11.2053 5.03068 10.0528 3.3187 8.38173 2.50936C6.71093 3.31874 5.55889 5.03076 5.55878 7.01184C5.55878 8.44476 6.16255 9.73581 7.12832 10.6476V12.9621C6.82724 13.0085 6.51889 13.0327 6.20485 13.0327C2.8798 13.0325 0.184021 10.3369 0.184021 7.01184C0.184172 3.68688 2.87989 0.991843 6.20485 0.991699C6.97268 0.991719 7.70646 1.1364 8.38173 1.39844C9.05698 1.13636 9.79078 0.991743 10.5586 0.991699ZM6.20485 2.012C3.44348 2.01215 1.20448 4.25047 1.20433 7.01184C1.20433 9.77334 3.44339 12.0122 6.20485 12.0124C6.50737 12.0124 6.80325 11.9836 7.09096 11.9321C5.54732 10.8419 4.53847 9.04528 4.53847 7.01184C4.53856 4.9784 5.54724 3.18156 7.09096 2.09155C6.80328 2.04008 6.50733 2.01201 6.20485 2.012Z",
          fill: _vm.fillColor,
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M16.7168 12.2514L7.55321 17.5416V6.96121L16.7168 12.2514Z",
          fill: _vm.fillColor,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }